var transformSupported = typeof document.createElement('span').style.transform !== 'undefined';

export default {
    supported: transformSupported,
    transform: function (el, x, y, z, scale, rotate, isNeedTranslate = false) {
        let transform = '', width, height, left, top;
        if (transformSupported) {
            if(isNeedTranslate){
                transform = 'translate3d(' + coordToCSS(x) + ', ' + coordToCSS(y) + ', ' + coordToCSS(z) + ')  translate(-50%, -50%)';
            }else{
                transform = 'translate3d(' + coordToCSS(x) + ', ' + coordToCSS(y) + ', ' + coordToCSS(z) + ')';
            }

            if (typeof scale === 'number') {
                transform += ' scale(' + scale + ')';
            }
            if (typeof rotate === 'number') {
                transform += ' rotate(' + rotate + 'deg)';
            }
            else if(typeof rotate === 'string' && rotate.indexOf('rotate') === 0) {
                transform += rotate;
            }
            el.style.webkitTransform = transform;
            el.style.MozTransform = transform;
            el.style.transform = transform;
        }
        else {
            if (['absolute', 'relative'].indexOf(getComputedStyle(el).position) === -1) {
                el.style.position = 'relative';
            }
            el.style.top = y + 'px';
            el.style.left = x + 'px';
            if (typeof scale === 'number') {
                if (el.dataset.width) {
                    width = parseFloat(el.dataset.width);
                    height = parseFloat(el.dataset.height);
                    left = parseFloat(el.dataset.left);
                    top = parseFloat(el.dataset.top);
                }
                else {
                    let styles = getComputedStyle(el);
                    width = parseFloat(styles.width);
                    height = parseFloat(styles.height);
                    left = parseFloat(styles.marginLeft);
                    top = parseFloat(styles.marginTop);
                    el.dataset.width = width;
                    el.dataset.height = height;
                    el.dataset.left = left;
                    el.dataset.top = top;
                }

                el.style.width = width * scale + 'px';
                el.style.height = height * scale + 'px';
                el.style.marginLeft = left * scale + 'px';
                el.style.marginTop = top * scale + 'px';
            }
        }
    }
};

function coordToCSS(coord) {
    return (coord || 0) + (typeof coord === 'string' ? '' : 'px');
}
